import Vue from 'vue';

export default new Vue({});



// WEBPACK FOOTER //
// ./utils/eventbus.js